import { getAPI , postAPI } from "../../api/api"
import { REACT_APP_JOB, REACT_APP_RECRUITER, REACT_APP_CUSTOMER, REACT_APP_JOBFILTER } from "../../utils/common"

export async function getAllPositions() {
    const Details = getAPI( REACT_APP_RECRUITER + "/list")
    return Details
}
export async function getPositions(searchValue : string , page : number, pageSize: number, data?: any){
    const Details = postAPI( REACT_APP_JOBFILTER + `/position-filter?search=${searchValue}&page=${page}&size=${pageSize}`, data)
    return Details
}

export async function postCandidateToJob(body: any) {
    const Details = postAPI( REACT_APP_JOB + '/candidate-position', body)
    return Details
}

export async function getCompany() {
    const Details = getAPI( REACT_APP_CUSTOMER + "/customer-list")
    return Details
}

export async function getAllocatedto() {
    const Details = getAPI( REACT_APP_RECRUITER + "/list")
    return Details
}

export async function getpositionsName() {
    const Details = getAPI( REACT_APP_JOBFILTER + "/position-title")
    return Details
}